import { useSetAtom } from 'jotai';
import { Button } from '@mui/material';

import { ApiBase } from '../../../api/apiBase';
import { ApiToken } from '../../../api/apiToken';
import {
  isBackdropOpenAtom,
  pageAtom,
  snackbarPropsAtom,
} from '../../../atoms';
import { LoginPageText } from '../../../texts';
import { PAGE } from '../../../constant/page';
import { Dispatch, SetStateAction } from 'react';

const LoginButton = (props: {
  formData: {
    email: string;
    password: string;
  };
  formValidation: {
    email: boolean;
    password: boolean;
  };
  setFormValidation: Dispatch<
    SetStateAction<{
      email: boolean;
      password: boolean;
    }>
  >;
}) => {
  const { formData, formValidation, setFormValidation } = props;

  const setIsBackdropOpen = useSetAtom(isBackdropOpenAtom);
  const setPage = useSetAtom(pageAtom);
  const snackbarProps = useSetAtom(snackbarPropsAtom);

  const validateForm = () => {
    const newFormValidation = {
      ...formValidation,
    };

    if (formData.email === '') {
      newFormValidation.email = false;
    }

    if (formData.password === '') {
      newFormValidation.password = false;
    }

    if (Object.values(newFormValidation).includes(false)) {
      setFormValidation(newFormValidation);
      return false;
    }

    return true;
  };

  const onClickLogin = () => {
    // guard block
    if (!validateForm()) {
      return;
    }

    setIsBackdropOpen(true);
    ApiToken.post(formData.email, formData.password)
      .then((value: any) => {
        ApiBase.setToken(value.token);
        setPage(value.acceptedTerms ? PAGE.MAIN : PAGE.TERMS_OF_USE_UPDATE);
      })
      .catch((error) => {
        console.log(error);
        snackbarProps({
          isOpen: true,
          type: 'error',
          message:
            'ログインできませんでした。メールアドレスとパスワードを確認してください。',
        });
      })
      .finally(() => {
        setIsBackdropOpen(false);
      });
  };

  return (
    <Button
      variant='contained'
      color={'primary'}
      fullWidth
      onClick={onClickLogin}
    >
      {LoginPageText.LoginButton_Label}
    </Button>
  );
};

export default LoginButton;
